import {keyBy, omit, some} from 'lodash';
import {
  DELETE_ACTIVITY,
  RECEIVE_ACTIVITY,
  EDIT_ACTIVITY,
  CANCEL_EDIT_ACTIVITY,
  SCROLLED_TO_ACTIVITY,
  NEW_ACTIVITY,
  RECEIVE_ACTIVITIES,
} from 'shared/portfolio/actions/activities';

export function activitiesReducer(state = {}, action) {
  switch (action.type) {
    case EDIT_ACTIVITY:
      return {
        ...state,
        [action.activity._id]: {
          ...action.activity,
          editing: true,
        },
      };
    case DELETE_ACTIVITY:
      return omit(state, action.id);
    case CANCEL_EDIT_ACTIVITY:
      if (action.activity.new) {
        return omit(state, action.activity._id);
      } else {
        return {
          ...state,
          [action.activity._id]: {
            ...action.activity,
            editing: false,
            scrollTo: true,
          },
        };
      }
    case SCROLLED_TO_ACTIVITY:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          scrollTo: false,
        },
      };
    case RECEIVE_ACTIVITY:
      return {...state, [action.activity._id]: action.activity};
    case NEW_ACTIVITY:
      if (some(state, 'new')) {
        return state;
      } else {
        return {
          ...state,
          [action.activity._id]: action.activity,
        };
      }
    case RECEIVE_ACTIVITIES:
      return {...state, ...keyBy(action.activities, '_id')};
    default:
      return state;
  }
}
